import React from 'react';
import Button from '../ui/Button';

export default function BulkActionBar({ selectedCount, actions }) {
  if (!selectedCount) return null;
  return (
    <div className="sp-bulk-bar" role="region" aria-label="Bulk actions">
      <div className="sp-bulk-count">{selectedCount} selected</div>
      <div className="sp-bulk-actions">
        {actions.map((action, index) => (
          <div key={action.id || `${action.label}-${index}`} className="sp-bulk-action">
            <Button
              size="sm"
              variant={action.variant || 'secondary'}
              onClick={action.onClick}
              disabled={action.disabled}
              aria-label={action.ariaLabel || action.label}
              title={action.disabled && action.disabledReason ? action.disabledReason : ''}
              type="button"
            >
              {action.label}
            </Button>
            {action.disabled && action.disabledReason && (
              <span className="sp-bulk-hint">{action.disabledReason}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
